var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        name: "previewModal",
        "content-classes": "default-modal width-md"
      },
      model: {
        value: _vm.opened,
        callback: function($$v) {
          _vm.opened = $$v
        },
        expression: "opened"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            {
              attrs: { slot: "header", color: "white", "text-color": "grey-9" },
              slot: "header"
            },
            [
              _c("q-toolbar-title", [_vm._v(_vm._s(_vm.$t("preview")))]),
              _c(
                "q-btn",
                {
                  attrs: { flat: "", dense: "" },
                  on: {
                    click: function($event) {
                      _vm.opened = false
                    }
                  }
                },
                [_c("q-icon", { attrs: { name: "close", color: "grey-8" } })],
                1
              )
            ],
            1
          ),
          _vm.supportsInlinePDF
            ? _c("div", { ref: "pdfPreview", staticStyle: { height: "70vh" } })
            : _c("div", { staticClass: "layout-padding" }, [
                _c("p", { staticClass: "text-center" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pdf_inline_not_supported")) +
                      "\n      "
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "flex items-center justify-center" },
                  [
                    _c(
                      "q-btn",
                      {
                        attrs: { color: "primary" },
                        on: { click: _vm.handlePDFDownload }
                      },
                      [_vm._v(_vm._s(_vm.$t("download")))]
                    )
                  ],
                  1
                )
              ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }